import { ButtonHTMLAttributes, useState } from 'react';

/**
 * Tab — a pill toggle used for date selectors and segmented filters.
 * Active is a solid --text fill (inverted label); inactive is a quiet
 * --surface pill that warms on hover. Group them in a flex row with gap.
 */
export interface TabProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Selected state. */
  active?: boolean;
  onClick?: () => void;
}

export function Tab({ active = false, onClick, children, style, ...props }: TabProps) {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        fontFamily: 'var(--font-sans)',
        fontSize: 'var(--fs-tab)',
        fontWeight: 500,
        border: 'none',
        borderRadius: 'var(--r-pill)',
        padding: '7px 15px',
        cursor: 'pointer',
        whiteSpace: 'nowrap',
        transition: 'background .18s, color .18s',
        background: active ? 'var(--text)' : (hover ? 'var(--pill-hover-bg)' : 'var(--surface)'),
        color: active ? 'var(--bg)' : (hover ? 'var(--text)' : 'var(--text-soft)'),
        ...style,
      }}
      {...props}
    >
      {children}
    </button>
  );
}

export default Tab;
